import { useState, useEffect } from 'react';

const POKEAPI_BASE = 'https://pokeapi.co/api/v2/pokemon';
const spriteCache = {}; // Client-side memory cache

export default function usePokemonSprites(pokemonIds = []) {
  const [sprites, setSprites] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!pokemonIds || pokemonIds.length === 0) {
      setSprites({});
      setLoading(false);
      return;
    }

    const fetchSprites = async () => {
      setLoading(true);
      setError(null);
      const result = {};

      try {
        await Promise.all(
          pokemonIds.map(async (id) => {
            if (!id) return;

            const normalizedId = id.toLowerCase().trim();
            
            // Check memory cache first
            if (spriteCache[normalizedId]) {
              result[normalizedId] = spriteCache[normalizedId];
              return;
            }

            try {
              const response = await fetch(
                `${POKEAPI_BASE}/${normalizedId}`
              );
              
              if (!response.ok) {
                result[normalizedId] = null;
                spriteCache[normalizedId] = null;
                return;
              }

              const data = await response.json();
              const spriteUrl =
                data.sprites?.other?.['official-artwork']?.front_default || null;
              
              result[normalizedId] = spriteUrl;
              spriteCache[normalizedId] = spriteUrl;
            } catch (err) {
              console.error(`Failed to fetch sprite for ${normalizedId}:`, err);
              result[normalizedId] = null;
              spriteCache[normalizedId] = null;
            }
          })
        );

        setSprites(result);
      } catch (err) {
        setError(err.message);
        console.error('Failed to fetch sprites:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSprites();
  }, [pokemonIds.join(',')]); // Join to avoid unnecessary re-renders

  return { sprites, loading, error };
}
